module.exports = __webpack_public_path__ + "img/아크메이지.f0eed536.png";